export default __webpack_public_path__ + "92148632642613fe94e24430daa52e29.png";